module.exports = __webpack_public_path__ + "static/img/progress-circle-success.4d3919f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progress-circle-success.svg
// module id = 5EiF
// module chunks = 1